export default "__VITE_ASSET__CLdwfIeC__"